import { render, staticRenderFns } from "./ProjectHistory.vue?vue&type=template&id=4000e37e&"
import script from "./ProjectHistory.vue?vue&type=script&lang=js&"
export * from "./ProjectHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports